import * as THREE from 'three'
import { useThree } from '@react-three/fiber'
import { createRef, ReactChildren, ReactFragment, ReactPortal, Ref, useRef } from 'react'
import { AmbientLight, Group, HemisphereLight, HemisphereLightHelper } from 'three'
// import { useAddGameElement } from "../../utils/game"
import GameElements from '../GameElements/GameElement/GameElement'
import { useHelper } from '@react-three/drei'

const Helper = ({children}:{children: ReactChildren | ReactFragment | ReactPortal}) => {
  const lightRef = useRef<Group>()
  useHelper(lightRef, HemisphereLightHelper, 1, 'red')
  return <group ref={lightRef as Ref<Group>}>
    {children}
  </group>
}
export const GameAmbientLight = () => {
  const { scene } = useThree()
  return (
    <GameElements
      addedToScene={obj => {
        // console.log(obj.children[0].type)

        // const hemisphereLightHelper = new THREE[`${obj.children[0].type}Helper`](obj as HemisphereLight, 2.2, 0xff0000)
        // scene.add(hemisphereLightHelper)
      }}
    >
      {/* <Helper> */}
        <hemisphereLight args={[0xff0000, 0x0000ff, 0.3]} />
      {/* </Helper> */}
      {/* <ambientLight intensity={1} color={0x264c5e} /> */}
    </GameElements>
  )
}
export default GameAmbientLight
